import { render, staticRenderFns } from "./meituanOrderList.vue?vue&type=template&id=f05a5f00&scoped=true"
import script from "./meituanOrderList.vue?vue&type=script&lang=js"
export * from "./meituanOrderList.vue?vue&type=script&lang=js"
import style0 from "./meituanOrderList.vue?vue&type=style&index=0&id=f05a5f00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05a5f00",
  null
  
)

export default component.exports